/**
 * Compass type enum
 * @enum {string}
 */
export enum EShadowType {
    NONE = 0,
    SV = 1,
    SM = 2
}

export enum ESunDirectionType {
    MANUAL = 0,
    DATETIME = 1
}

export enum ELightingDateTimeType {
    MODEL = 0,
    LOCAL = 1
}

export type ICBType = () => void;
